import React from 'react';
import ReactDOM from 'react-dom';
import PractitionersMap from './practitioners-map.jsx';
import PractitionersItem from './practitioners-item.jsx';
import { populate } from './../utils/populate.js';

class Practitioners extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      baseQuery: "/rest/practitioners/",
      query: "",
      data: [],
      mapTitles: [],
      mapData: []
    };

    this.populateAll = this.populateAll.bind(this);

  }

  componentDidMount() {
    document.documentElement.scrollTop = 1;
    var practitioner = document.getElementById("react--practitioners").dataset.term;

    this.setState({
      query: practitioner + '?_format=json'
    }, () => {
      this.populateAll()
    })


  }

  populateAll() {
    const { baseQuery, query } = this.state;
    const that = this;
    populate(`${baseQuery}${query}`).then(function( response ){
      that.setState({
        data: response
      })
      if(response.length > 0){

        let mapTitles = [];
        let mapData = [];
        console.log('state', that.state)
        response.map(item => {
          mapTitles = mapTitles.concat([item.title])
          mapData = mapData.concat([{
            latt: parseFloat(item.field_latitude),
            long: parseFloat(item.field_longitude)
          }])
        })
        that.setState({
          mapTitles,
          mapData
        })
      }
    });
  }

  render() {
    const { data, mapTitles, mapData} = this.state;

      return(
        <div>
          { mapData.length > 0 && <PractitionersMap titles={mapTitles} data={mapData}/> }
          <div className="practitioners--list page--section">
            <div className="container">
              <div className="grid clearfix">
                {
                  data.map((item, index) => {
                    return(
                      <PractitionersItem item={item} key={index} index={index} />
                    );
                  })
                }
              </div>
            </div>
          </div>
        </div>
      )
  }
}

if ( document.getElementById('react--practitioners') ) {
  ReactDOM.render(
    <Practitioners/>,
    document.getElementById('react--practitioners')
  );

}









